import { combineReducers } from 'redux';
import cybersource from './cybersource';

export default combineReducers({ cybersource });
